import { render, staticRenderFns } from "./GridRecordHistory.vue?vue&type=template&id=19b7d19e"
import script from "./GridRecordHistory.vue?vue&type=script&lang=js"
export * from "./GridRecordHistory.vue?vue&type=script&lang=js"
import style0 from "./GridRecordHistory.vue?vue&type=style&index=0&id=19b7d19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports